import React, { createContext, ReactNode, useEffect } from "react";
import { useParams } from "react-router-dom";
import { constants } from "@/constants";
import {Chatbot, ChatSettings} from "@/models/chatbot.ts";
import { snakeToCamelObj } from "@/utils/utils.ts";

export const ChatbotContext = createContext<{
  chatSettings: ChatSettings | null;
  setSettings: (settings: ChatSettings) => void;
  viewChatbot: Chatbot | null;
  invalidateChatbot: () => void;
}>({
  chatSettings: null,
  setSettings: () => {},
  viewChatbot: null,
  invalidateChatbot: () => {},
});

interface UserProviderProps {
  children: ReactNode;
}

export const ChatbotProvider = ({ children }: UserProviderProps) => {
  const { chatbotID } = useParams();

  const [chatSettings, setSettings] = React.useState<ChatSettings | null>(null);
  const [viewChatbot, setChatbot] = React.useState<any>(null);

  const getData = async () => {
    if (!chatbotID) {
      return;
    }

    let res = await fetch(`${constants.url.API_PREFIX}chatbot/${chatbotID}`);

    let data = await res.json();
    data = snakeToCamelObj(data);
    if (data.settings) {
      setSettings(data.settings as ChatSettings);
      setChatbot(data);
    }
  };

  useEffect(() => {
    if (chatbotID) {
      getData();
    } else {
      setSettings(null);
      setChatbot(null);
    }
  }, [chatbotID]);

  const invalidateChatbot = async () => {
    await getData();
  };

  return (
    <ChatbotContext.Provider
      value={{ chatSettings, setSettings, viewChatbot, invalidateChatbot }}
    >
      {children}
    </ChatbotContext.Provider>
  );
};
